/* Copyright 2013 The MathWorks, Inc. */

/*
This function adds type checking by checking the default data type of the properties
 */

define([
    "mw-log/Log"
], function (Log) {
    return function (args) {
        args = args || {};
        if (typeof (args.type) !== "string") {
            Log.error(args.type, "Type property is required");
        }
        if (typeof (args.notInAction) !== "boolean") {
            Log.error(args.notInAction, "NotInAction property is required");
        }
        if (typeof (args.required) !== "boolean") {
            Log.error(args.required, "Required property is required");
        }
        // Default value can be string, number of any other type
        // For example, for minimum is a number where as for selectedItems, the default value is empty array
        if (args.defaultValue === undefined) {
            Log.error(args.defaultValue, "DefaultValue  property is required");
        }
        return args;
    };

});